export function unknownToNil(value: string | null | undefined): string | undefined {
    return value === undefined || value === null || value === 'UNKNOWN' ? undefined : value;
}
